import request from '@/utils/request';

export function fetchList(query) {
    return request({
        url: 'https://viaglobal.pl/api//legals',
        method: 'get',
        params: query,
    });
}

export function fetchLegal(id) {
    return request({
        url: 'https://viaglobal.pl/api//legals/' + id,
        method: 'get',
    });
}

// export function createLegal(data) {
//     return request({
//         url: 'https://viaglobal.pl/api//legals',
//         method: 'post',
//         data,
//     });
// }

// export function createLegal(data) {
//     return request({
//         url: 'https://viaglobal.pl/api//print1',
//         method: 'post',
//         data,
//         responseType: 'blob', // Crucial for file downloads
//         headers: {
//             'Content-Type': 'application/json',
//         }
//     });
// }
export function createDocument(data) {
    return request({
        url: 'https://viaglobal.pl/api//document',
        method: 'post',
        data,
    });
}

export function createLegal(data) {
    return request({
        url: 'https://viaglobal.pl/api//print1',
        method: 'post',
        data,
    });
}

export function updateLegal(data) {
    return request({
        url: 'https://viaglobal.pl/api//legals/' + data.id,
        method: 'put',
        data,
    });
}

export function deleteLegal(data) {
    return request({
        url: 'https://viaglobal.pl/api//legals/' + data.id,
        method: 'delete',
        data,
    });
}

export function activateLegal(id) {
    return request({
        url: 'https://viaglobal.pl/api//legals-activate/' + id,
        method: 'get',
        id,
    });
}

export function sendMessage(data) {
    return request({
        url: 'https://viaglobal.pl/api//actualization/message',
        method: 'post',
        data,
    });
}
